var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEditMini = function SvgEditMini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    fillRule: "evenodd",
    d: "m3.522 9.535.007-.007L8.196 4.86l2-2a.667.667 0 0 1 .943 0l2 2c.26.26.26.683 0 .943l-6.667 6.667a.67.67 0 0 1-.471.195H4a.667.667 0 0 1-.667-.667v-2a.67.67 0 0 1 .188-.464M6 11.056l3.724-3.723-1.058-1.058L4.943 10zm3.61-5.723 1.056 1.057 1.058-1.057-1.058-1.058z",
    clipRule: "evenodd"
  })));
};
export default SvgEditMini;